import React, { FC, useState, useEffect } from 'react';
import { useToast } from '../Toast';
import { YesIcon, ContentCopyIcon } from '@clearcover/atlas';
import styles from './styles.module.css';
import classNames from 'classnames';

export const CopyContentButton: FC<{ value: any; className?: string }> = ({
  value,
  className,
}) => {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 1500);
    }
  }, [copied, setCopied, toast, value]);
  return copied ? (
    <YesIcon
      className={classNames(styles.success, className)}
      height={24}
      width={24}
    />
  ) : (
    <ContentCopyIcon
      className={classNames(styles.copy, className)}
      onClick={() => {
        navigator.clipboard.writeText(value).then(() => {
          toast({
            message: 'Copied',
            position: 'bottom',
            withFooter: false,
            withSecondaryNav: false,
          });
        });
        if (!copied) setCopied((l) => !l);
      }}
      height={24}
      width={24}
    />
  );
};
